import React, { useEffect, useRef } from "react";

const BUTTON_ID = process.env.REACT_APP_RAZORPAY_BUTTON_ID;

// Embeds Razorpay's hosted Payment Button, prefilled with the member's name/email so the
// webhook can match the completed payment back to their account (see backend /api/payments/razorpay/webhook).
export default function RazorpayButton({ email, name }) {
  const formRef = useRef(null);

  useEffect(() => {
    const form = formRef.current;
    if (!form || !BUTTON_ID) return;
    form.innerHTML = "";
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    script.async = true;
    script.setAttribute("data-payment_button_id", BUTTON_ID);
    if (email) script.setAttribute("data-prefill.email", email);
    if (name) script.setAttribute("data-prefill.name", name);
    form.appendChild(script);
  }, [email, name]);

  if (!BUTTON_ID) return null;
  return <form ref={formRef} data-testid="razorpay-pay-form" />;
}
